export function TripSummaryTitle({ title }: { title: string }) {
  return <div className="text-sm font-medium lg:text-base">{title}</div>;
}
